import { createContext } from 'react';
export const RFConfigContext = createContext({});
//# sourceMappingURL=RFConfigContext.js.map